import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface AddCalendarEventData {
    eventDescription: string;
  }

@Component({
    selector: 'tv-calendar-add-event',
    templateUrl: 'add.calendar.event.component.html',
})
export class AddCalendarEventComponent {

    constructor(
      public dialogRef: MatDialogRef<AddCalendarEventComponent>,
      @Inject(MAT_DIALOG_DATA) public data: AddCalendarEventData) {

      }

    onCancel(): void {
      this.dialogRef.close();
    }

}
